import Layout from "./src/layouts/TransitionLayout";

export default ({ props, element }) => {
	return <Layout {...props}>{element}</Layout>;
};
